import "./CSS/Banner.css"
import Navbar from "./Navbar"
import PlaygroundAnimation from "./PlaygroundAnimation"

import { userContext } from "../App"
import { useContext } from "react"
import { useNavigate } from "react-router-dom"

import Loading from "../Loading"

const Banner = () => {

    let navigate = useNavigate()

    return (
        <div className="banner">
            <Navbar></Navbar>
            <div className="lower-half">
                <div className="lower-left-half">
                    <h2 className="info-header">Algorithms Expert</h2>
                    <p className="info">The ultimate clone of AlgoExpert</p>
                    <p className="info">Made for learning purposes only</p>
                    <button className="buy-button" style={{marginTop: '1rem'}} onClick={() => navigate("/purchase")}>
                        <h3 style={{margin: "5px"}}>Buy Algorithms Expert</h3>
                    </button>
                </div>
                <div className="lower-right-half">
                    <PlaygroundAnimation></PlaygroundAnimation>
                </div>
            </div>

        </div>
    )
}

export default Banner
